import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';

// Material components
import {
    Paper,
    Typography,
    Grid,
    TextField,
    Select,
    FormControl,
    MenuItem
} from '@material-ui/core';

import Collapse from '@material-ui/core/Collapse';

import InfoIcon from '@material-ui/icons/InfoOutlined';

import NumberFormat from 'react-number-format';

//Components
import {
    Button,
} from 'devextreme-react';

import ModuliDocMag from './moduli/ModuliDocMag';
import ModuliDistBase from './moduli/ModuliDistBase';
import ModuliContabilita from './moduli/ModuliContabilita';
import ModuliGenerali from './moduli/ModuliGenerali';
import ModuliVerticali from './moduli/ModuliVerticali';

import ConfirmationDialog from './../shared/ConfirmationDialog';
import Progress from './../shared/Progress';
import ActionProgress from './../shared/ActionProgress';

import { SmallFormContainer } from './../shared/SmallFormContainer';
import FormFieldNonRivendibile from './form/FormFieldNonRivendibile';
import FormFieldDataDecorrenza from './form/FormFieldDataDecorrenza';

// utils
import format from 'date-fns/format';
import parseJSON from 'date-fns/parseJSON';

// css
import { withStyles } from '@material-ui/core';
const styles = theme => ({
    paperMain: {
        padding: '10px',
        textAlign: 'center',
        minHeight: "600px",
        position: 'relative',
    },
    paper: {
        padding: '12px',
        textAlign: 'center',
    },
    mainGrid: {
        position: 'relative',
    },
    paperListContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '100%',
    },
    paperRight: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '100%',
        minHeight: '624px',
    },
    paperVerticali: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minWidth: '100%',
    },
    rightPanel: {
        height: '100%'
    },
    leftPanel: {
        alignContent: 'space-between'
    },
    alignCenter: {
        display: 'flex',
        justifyContent: 'center'
    },
    alignLeft: {
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center'
    },
    dividerButton: {
        borderTop: '1px solid #ddd',
        marginTop: '20px',
        paddingTop: '20px !important'
    },
    paperForm: {
        marginTop: '10px',
        marginBottom: '10px'
    },
    formField: {
        minWidth: '100%',
    },
    paperFormContainer: {
        padding: '20px',
    },
    paperInfoContainer: {
        padding: '10px',
        backgroundColor: '#11d3ff26',
    },
    typographyBody1: {
        minWidth: '100%',
        fontSize: '1.1rem'
    },
    typographyVerticali: {
        minWidth: '100%',
        margin: '10px'
        //fontSize: '1.1rem'
    },
    warning: {
        backgroundColor: '#ffef11',
    },
    divider: {
        width: '100%',
        marginBottom: '10px',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)'
    }
});


function formatLength(value, maxLength) {
    let format = value.substring(0, maxLength);

    return format;
}

//Solo numeri sulla TextField
function NumberFormatCustom(props) {
    const { inputRef, onChange, maxLength, ...other } = props;

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            allowNegative={false}
            allowLeadingZeros
            format={(value) => formatLength(value, maxLength)}
        />
    );
}


const profili_predefiniti = [
    'LITE EDITION',
    'PERSONAL EDITION',
    'MINI BUSINESS',
    'SMALL BUSINESS',
    'STANDARD',
    'BUSINESS',
    'ULTIMATE',
];

class GestioneModuliCmp extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isConfirmationDialogOpen: false,    //dialog di conferma creazione
            isDataDecorrDialogOpen: false,      //dialog modifica data decorrenza
            isReadOnly: false                   // true se non è prima attivazione e se non è CODICEADMIN   
        };

        this.showConfirmationDialog = this.showConfirmationDialog.bind(this);
        this.showDataDecorrDialog = this.showDataDecorrDialog.bind(this);

        this.changeAndValidateField = this.changeAndValidateField.bind(this);
        this.changeAndValidateSNOld = this.changeAndValidateSNOld.bind(this);
        this.handleChanges = this.handleChanges.bind(this);

        this.salvaModifiche = this.salvaModifiche.bind(this);
        this.submitChanges = this.submitChanges.bind(this);
        this.submitNewConfigurationChanges = this.submitNewConfigurationChanges.bind(this);
        this.clearAll = this.clearAll.bind(this);
    }

    componentDidUpdate(propsPrecedenti) {
        const { getCodiceModuliRequestStatus, codiceUtente, prima_attivazione } = this.props;

        if (getCodiceModuliRequestStatus !== propsPrecedenti.getCodiceModuliRequestStatus) {
            if (codiceUtente === 'CODICEADMIN') {
                this.setState({ isReadOnly: false });
            }
            else if (prima_attivazione === true) {
                this.setState({ isReadOnly: false });
            }
            else if (prima_attivazione === false) {
                this.setState({ isReadOnly: true });
            }
        }

        //se is_serial_old_used è cambiato, allora rifaccio la validazione
        if (this.props.is_serial_old_used !== propsPrecedenti.is_serial_old_used) {
            this.props.validateSNOld(this.props.is_serial_old_used);
        }
    }

    showConfirmationDialog() {
        this.setState({ isConfirmationDialogOpen: !this.state.isConfirmationDialogOpen });
    }

    showDataDecorrDialog() {
        this.setState({ isDataDecorrDialogOpen: !this.state.isDataDecorrDialogOpen });
    }

    changeAndValidateField(field, newValue) {
        this.props.handleChangeField(field, newValue);
        this.props.validateField(field);
    }

    changeAndValidateSNOld(newValue) {
        const { handleChangeField, isSerialOldUsed, validateSNOld, selected_license } = this.props;

        handleChangeField('serial_number_old', newValue);
        isSerialOldUsed(newValue, selected_license.ProductKey);
        validateSNOld(this.props.is_serial_old_used);
    }

    handleChanges() {
        const { isDataDecorrChanged } = this.props;

        if (isDataDecorrChanged) this.showDataDecorrDialog();
        else this.submitChanges();
    }

    salvaModifiche() {
        this.props.validateField('all');

        if ((this.props.isModuliChanged && this.props.isDataDecorrChanged && this.props.isSNOldChanged) || this.props.isValid) {
            this.showConfirmationDialog();
        }
    }


    submitChanges() {

        const { selected_license, isModuliChanged, isSNOldChanged, isDataDecorrChanged } = this.props;

        if (isSNOldChanged)
            this.props.setSerialNumberOld(selected_license.ProductKey, selected_license.ID, this.props.serial_number_old, this.props.codiceUtente);


        if (isModuliChanged || isDataDecorrChanged)
            this.props.setCodiceModuli(selected_license.ProductKey, selected_license.IDModulo, this.props.data_decorrenza, this.props.codiceUtente, selected_license.Tipologia, selected_license.SerialNumber, this.props.new_moduli);

    }

    submitNewConfigurationChanges() {

        const { selected_license, isModuliChanged, isSNOldChanged, isDataDecorrChanged } = this.props;

        if (isSNOldChanged)
            this.props.setSerialNumberOld(selected_license.ProductKey, selected_license.ID, this.props.serial_number_old, this.props.codiceUtente);

        if (isModuliChanged || isDataDecorrChanged)
            this.props.insertModuli(selected_license.ProductKey, selected_license.ID, this.props.data_decorrenza, this.props.codiceUtente, selected_license.Tipologia, selected_license.SerialNumber, this.props.new_moduli);

    }

    // se la modifica moduli è andata a buon fine ritorno a GridLicenze e resetto i valori di gestione-moduli
    clearAll() {
        this.props.changeViewSelection('');
        this.props.resetLicenseDetails();
        this.props.resetModuli();
        this.props.refreshLicenses(this.props.codiceUtente);
        this.props.resetFilters();
    }

    render() {
        const { classes, selected_license, new_moduli, data_decorrenza, serial_number_old, errorText, codiceUtente,
            handleChangeFieldModulo, handleChangeField, onProfiloPredefChange, setAllActive, tipologia,
            isValid, isModuliChanged, isDataDecorrChanged, isSNOldChanged, prima_attivazione, profilo_predefinito,
            getCodiceModuli } = this.props;
        const { isConfirmationDialogOpen, isDataDecorrDialogOpen, isReadOnly } = this.state;

        return (

            <Fragment>
                <Collapse in={this.props.getCodiceModuliRequestStatus === 'RESOLVED'} timeout={2000}>

                    <Grid container spacing={1} className={classes.mainGrid}>

                        <Grid item xs={12} sm={6} className={classes.alignCenter}>

                            <Grid container spacing={1} className={classes.leftPanel}>

                                {prima_attivazione &&
                                    <Grid item xs={12} >
                                        <Paper className={classes.paperInfoContainer}>
                                            <Grid container spacing={3} >
                                                <Grid item xs={1} className={classes.alignCenter}>
                                                    <InfoIcon fontSize="large" />
                                                </Grid>
                                                <Grid item xs={11} >
                                                    <Typography className={classes.typographyBody1} variant="body1">
                                                        Prima Attivazione
                                        </Typography>
                                                    <Typography variant="body2">
                                                        Una volta settati i moduli, questi non saranno più modificabili dall'utente e per farlo sarà necessario contattare l'assistenza L@ZIENDALE.
                                        </Typography>
                                                </Grid>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                }


                                <Grid item xs={12} >
                                    <Paper className={classes.paperFormContainer}>
                                        <Grid container spacing={3} >

                                            <SmallFormContainer labelText="Product Key">
                                                <Typography className={classes.typographyBody1} variant="body1">
                                                    {selected_license.ProductKey}
                                                </Typography>
                                            </SmallFormContainer>

                                            <SmallFormContainer labelText="Serial Number">
                                                <Typography className={classes.typographyBody1} variant="body1">
                                                    {selected_license.SerialNumber}
                                                </Typography>
                                            </SmallFormContainer>

                                            <SmallFormContainer labelText="Tipologia">
                                                <Typography className={classes.typographyBody1} variant="body1">
                                                    {tipologia}
                                                </Typography>
                                            </SmallFormContainer>

                                            <SmallFormContainer labelText="Scadenza">
                                                <Typography className={classes.typographyBody1} variant="body1">
                                                    {selected_license.DataScadenza ? format(parseJSON(selected_license.DataScadenza), 'dd/MM/yyyy') : 'nessuna'}
                                                </Typography>
                                            </SmallFormContainer>

                                            <div className={classes.divider}/>

                                            <FormFieldNonRivendibile
                                                non_rivendibile={new_moduli.LicNonRivend}
                                                handleChangeField={handleChangeField}
                                                setAllActive={() => setAllActive(this.props.new_moduli)}
                                                isReadOnly={isReadOnly}
                                            />

                                            <SmallFormContainer labelText="Utenti abilitati">
                                                <TextField
                                                    className={classes.formField}
                                                    value={new_moduli.NumUtenti}
                                                    onChange={e => this.changeAndValidateField('NumUtenti', e.target.value)}
                                                    InputLabelProps={{ shrink: true }}
                                                    InputProps={{ inputComponent: NumberFormatCustom, inputProps: { maxLength: 2 }, readOnly: isReadOnly }}
                                                    variant="outlined"
                                                    size="small"
                                                    error={errorText.NumUtenti !== '' ? true : false}
                                                    helperText={errorText.NumUtenti !== '' ? errorText.NumUtenti : null}
                                                />
                                            </SmallFormContainer>

                                            {
                                                (selected_license.Tipologia === 'Enterprise' && !isReadOnly) &&
                                                <SmallFormContainer labelText="Decorrenza Moduli">
                                                    <FormFieldDataDecorrenza
                                                        data_decorrenza={data_decorrenza}
                                                        handleChangeField={date => this.changeAndValidateField('data_decorrenza', date)}
                                                        errorText={errorText}
                                                    />
                                                </SmallFormContainer>
                                            }


                                            {
                                                (selected_license.Tipologia === 'Enterprise' && isReadOnly) &&
                                                <SmallFormContainer labelText="Data Decorrenza">
                                                    <Typography className={classes.typographyBody1} variant="body1">
                                                        {format(data_decorrenza, 'dd/MM/yyyy')}
                                                    </Typography>
                                                </SmallFormContainer>
                                            }

                                            {codiceUtente === 'CODICEADMIN' &&
                                                <SmallFormContainer labelText="Serial number old">
                                                    <TextField
                                                        className={classes.formField}
                                                        value={serial_number_old}
                                                        onChange={e => this.changeAndValidateSNOld(e.target.value)}
                                                        InputLabelProps={{ shrink: true }}
                                                        InputProps={{ inputComponent: NumberFormatCustom, inputProps: { maxLength: 6 } }}
                                                        variant="outlined"
                                                        size="small"
                                                        error={errorText.serial_number_old !== '' ? true : false}
                                                        helperText={errorText.serial_number_old !== '' ? errorText.serial_number_old : null}
                                                    />
                                                </SmallFormContainer>
                                            }

                                        </Grid>
                                    </Paper>
                                </Grid>

                                {(tipologia === 'Enterprise' && isReadOnly === false) ?
                                    <Grid item xs={12} >
                                        <Paper className={classes.paperFormContainer}>
                                            <Grid container spacing={3} >
                                                <SmallFormContainer labelText="Profili Predefiniti">
                                                    <FormControl
                                                        variant="outlined"
                                                        size="small"
                                                        fullWidth
                                                    >
                                                        <Select
                                                            className={classes.formField}
                                                            value={profilo_predefinito}
                                                            onChange={e => onProfiloPredefChange(e.target.value)}
                                                        >
                                                            <MenuItem value=''>
                                                                <em>Nessuno</em>
                                                            </MenuItem>
                                                            {profili_predefiniti.map((item, index) =>
                                                                <MenuItem value={item} key={index}>{item}</MenuItem>
                                                            )}
                                                        </Select>
                                                    </FormControl>
                                                </SmallFormContainer>
                                            </Grid>
                                        </Paper>
                                    </Grid>
                                    :
                                    null
                                }


                                <Grid item xs={12} >
                                    <Paper className={classes.paperListContainer}>
                                        <ModuliDocMag
                                            doc_mag={new_moduli.MagDoc}
                                            handleChangeFieldModulo={handleChangeFieldModulo}
                                            isReadOnly={isReadOnly}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} >
                                    <Paper className={classes.paperListContainer}>
                                        <ModuliDistBase
                                            dist_base={new_moduli.DistBase}
                                            handleChangeFieldModulo={handleChangeFieldModulo}
                                            tipologia={tipologia}
                                            isReadOnly={isReadOnly}
                                        />
                                    </Paper>
                                </Grid>
                                <Grid item xs={12} >
                                    <Paper className={classes.paperListContainer}>
                                        <ModuliContabilita
                                            contabilita={new_moduli.Contabilita}
                                            handleChangeFieldModulo={handleChangeFieldModulo}
                                            tipologia={tipologia}
                                            isReadOnly={isReadOnly}
                                        />
                                    </Paper>
                                </Grid>

                            </Grid>

                        </Grid>

                        <Grid item xs={12} sm={6} className={classes.rightPanel}>

                            <Grid container >
                                <Paper className={classes.paperRight}>
                                    <ModuliGenerali
                                        generali={new_moduli.Generali}
                                        handleChangeFieldModulo={handleChangeFieldModulo}
                                        isReadOnly={isReadOnly}
                                    />
                                </Paper>

                            </Grid>

                        </Grid>



                        {tipologia === 'Enterprise' &&
                            <Fragment>
                                <Typography className={classes.typographyVerticali} variant="h6">
                                    Verticali:
                        </Typography>
                                <Grid item xs={12} className={classes.alignCenter}>
                                    <Grid container >
                                        <Paper className={classes.paperVerticali}>
                                            <ModuliVerticali
                                                verticali={new_moduli.Verticali}
                                                handleChangeFieldModulo={handleChangeFieldModulo}
                                                isReadOnly={isReadOnly}
                                            />
                                        </Paper>
                                    </Grid>
                                </Grid>
                            </Fragment>
                        }


                        <Grid item xs={12} className={`${classes.alignCenter} ${classes.dividerButton}`}>
                            <Button
                                width={120}
                                text="Salva"
                                type="default"
                                stylingMode="contained"
                                disabled={((!isModuliChanged && !isDataDecorrChanged && !isSNOldChanged) || !isValid) ? true : false}
                                onClick={() => this.salvaModifiche()}
                            />
                        </Grid>

                        <ConfirmationDialog
                            isOpen={isConfirmationDialogOpen}
                            showDialog={this.showConfirmationDialog}
                            title={"Gestione moduli"}
                            message={"Confermi le modifiche effettuate ai moduli della licenza " + selected_license.ProductKey + "?"}
                            action={this.handleChanges}
                        />

                        <ConfirmationDialog
                            isOpen={isDataDecorrDialogOpen}
                            showDialog={this.showDataDecorrDialog}
                            title={"Modifica data decorrenza"}
                            message={"La data decorrenza è stata modificata, si desidera creare una nuova configurazione con nuova data decorrenza o modificare l'attuale configurazione?"}
                            buttonLeftText={"Nuova Configurazione"}
                            buttonRightText={"Modifica Attuale"}
                            action={this.submitChanges}
                            leftAction={this.submitNewConfigurationChanges}
                        />
                    </Grid>
                </Collapse>

                <Collapse in={this.props.getCodiceModuliRequestStatus !== 'RESOLVED'} timeout={500}>
                    <Paper className={classes.paperMain}>
                        <Progress
                            status={this.props.getCodiceModuliRequestStatus}
                            cancelAction={() => this.clearAll()}
                            tryAgainAction={() => getCodiceModuli(selected_license.ProductKey, selected_license.IDModulo, selected_license.Tipologia)}
                            errorMessage='Non è stato possibile caricare i moduli della licenza selezionata.'

                        />
                    </Paper>
                </Collapse >

                <ActionProgress
                    status={this.props.setCodiceModuliRequestStatus}
                    afterResolvedAction={() => this.clearAll()}
                    tryAgainAction={() => this.submitChanges()}
                />
                <ActionProgress
                    status={this.props.insertModuliRequestStatus}
                    afterResolvedAction={() => this.clearAll()}
                    tryAgainAction={() => this.submitNewConfigurationChanges()}
                />
            </Fragment>
        );

    }
}

GestioneModuliCmp.propTypes = {
    selected_license: PropTypes.shape({
        ProductKey: PropTypes.any,
        ID: PropTypes.any,
        SerialNumberOld: PropTypes.any,
        IDModulo: PropTypes.any,
        Tipologia: PropTypes.any,
        DataDecorr: PropTypes.any,
        DataScadenza: PropTypes.any,
    }).isRequired,

    //getCodiceModuli
    getCodiceModuli: PropTypes.func.isRequired,
    getCodiceModuliRequestStatus: PropTypes.string.isRequired,

    moduli: PropTypes.shape({}).isRequired,
    new_moduli: PropTypes.shape({}).isRequired,

    data_decorrenza: PropTypes.instanceOf(Date),
    serial_number_old: PropTypes.string,

    isValid: PropTypes.bool.isRequired,
    isModuliChanged: PropTypes.bool.isRequired,
    isDataDecorrChanged: PropTypes.bool.isRequired,
    isSNOldChanged: PropTypes.bool.isRequired,

    tipologia: PropTypes.string.isRequired,
    profilo_predefinito: PropTypes.string.isRequired,
    prima_attivazione: PropTypes.bool.isRequired,
    errorText: PropTypes.shape({}).isRequired,

    handleChangeFieldModulo: PropTypes.func.isRequired,
    handleChangeField: PropTypes.func.isRequired,
    setAllActive: PropTypes.func.isRequired,
    onProfiloPredefChange: PropTypes.func.isRequired,
    validateField: PropTypes.func.isRequired,
    validateSNOld: PropTypes.func.isRequired,

    //getLicenseDetails
    getLicenseDetailsRequestStatus: PropTypes.string.isRequired,


    //setCodiceModuli
    setCodiceModuli: PropTypes.func.isRequired,
    setCodiceModuliRequestStatus: PropTypes.string.isRequired,
    isInserted_SetCodiceModuli: PropTypes.string.isRequired,

    //insertModuli
    insertModuli: PropTypes.func.isRequired,
    insertModuliRequestStatus: PropTypes.string.isRequired,
    isInserted_InsertModuli: PropTypes.string.isRequired,

    //setSerialNumberOld
    setSerialNumberOld: PropTypes.func.isRequired,
    setSerialNumberOldRequestStatus: PropTypes.string.isRequired,

    //isSerialOldUsed
    isSerialOldUsed: PropTypes.func.isRequired,
    is_serial_old_used: PropTypes.bool.isRequired,

    resetModuli: PropTypes.func.isRequired,
    changeViewSelection: PropTypes.func.isRequired,

    codiceUtente: PropTypes.string.isRequired,
};

export default withStyles(styles)(GestioneModuliCmp);